import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";

export default function ComingSoonPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/coming-soon").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Header />
      <section className="border-b border-white/10 bg-black/40">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-12 md:pt-28">
          <p className="af-mono text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] mb-4">
            // Drop incoming
          </p>
          <h1
            className="af-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.92]"
            data-testid="coming-soon-title"
          >
            Coming soon
          </h1>
          <p className="text-zinc-400 mt-6 max-w-2xl">
            New gear in the pit — Fortnite collectibles, airless sports balls and
            3D-printed F1 art. Tap any item to take a closer look.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 grid md:grid-cols-2 gap-8">
        {items.map((it) => (
          <Link
            to={`/product/${it.slug}`}
            key={it.slug}
            className="af-card relative overflow-hidden group block"
            data-testid={`coming-soon-detail-${it.slug}`}
          >
            <div className="aspect-[4/3] relative overflow-hidden bg-black">
              <img
                src={it.image}
                alt={it.name}
                className="w-full h-full object-cover opacity-85 group-hover:opacity-100 transition-opacity duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <span className="absolute top-4 left-4 af-mono text-[10px] uppercase tracking-[0.25em] bg-[#00E5FF] text-black px-2 py-1">
                Soon
              </span>
            </div>
            <div className="p-8">
              <p className="af-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                {it.category}
              </p>
              <h3 className="af-display text-3xl font-bold uppercase tracking-tight mt-2">
                {it.name}
              </h3>
              <p className="text-zinc-400 mt-3">{it.tagline}</p>
            </div>
          </Link>
        ))}
      </section>
      <Footer />
    </div>
  );
}
